// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import React from 'react'
import Select, { getOptions, getValue } from './Select'

import type { Props as SelectProps } from './Select'

type Props = SelectProps

type State = {
  options: Array<any>
}

class CreatableSelect extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      options: getOptions(props.options),
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { options } = this.props

    if (!isEqual(options, prevProps.options)) {
      this.setState({
        options: getOptions(options),
      })
    }
  }

  onChange = (newValue: any, actionMeta: any) => {
    const { options } = this.props

    if (actionMeta.action === 'clear') {
      this.setState({
        options: getOptions(options),
      })
    }

    if (
      actionMeta.action === 'select-option' &&
      !!find(getOptions(options), (option) => option.value === newValue.value)
    ) {
      this.setState({
        options: getOptions(options),
      })
    }

    if (this.props.onChange) {
      this.props.onChange(newValue, actionMeta)
    }
  }

  onHandleCreate = (inputValue: any) => {
    const options = getOptions([inputValue, ...this.props.options])

    this.setState({
      options,
    })

    if (this.props.onChange) {
      this.props.onChange(getValue(inputValue, options), {
        action: 'select-option',
      })
    }
  }

  render() {
    const { options } = this.state

    return (
      <Select
        {...this.props}
        options={options}
        onChange={this.onChange}
        onCreateOption={this.onHandleCreate}
        isClearable
      />
    )
  }
}

export default CreatableSelect
